import { PropsWithChildren, useCallback } from 'react';
import { useAppContext } from 'src/contexts/AppContext';
import { FilterQueryContextProvider } from 'src/contexts/FilterQueryContext';
import { ReportMetricsContextProviderV2 } from 'src/contexts/ReportMetricsContext/ReportMetricsContextV2';
import { ReportConfigV2 } from 'src/hooks/reportConfigs';
import { EmptyReportV2SaleLineItemQuery } from 'src/utils/eventQueryUtils';
import {
  ReportV2Client,
  UIReportV2SaleLineItemQuery,
} from 'src/WebApiController';

export function ReportsSaleLineItemContextProviderV2({
  reportConfig,
  isExport,
  children,
}: PropsWithChildren<{
  reportConfig: ReportConfigV2;
  isExport?: boolean;
}>) {
  const { activeAccountWebClientConfig } = useAppContext();

  const getReportMetrics = useCallback(
    (
      tempReportConfig: ReportConfigV2,
      filters: UIReportV2SaleLineItemQuery,
      pageNumber: number
    ) => {
      return new ReportV2Client(
        activeAccountWebClientConfig
      ).getSaleLineItemReportMetrics({
        ...tempReportConfig.request,
        pageNumber,
        filters,
        // Explicitly ensure useAccountCurrency is included if it exists
        useAccountCurrency: (tempReportConfig.request as any)
          .useAccountCurrency,
      });
    },
    [activeAccountWebClientConfig]
  );

  const getReportMetricsSummary = useCallback(
    (
      tempReportConfig: ReportConfigV2,
      filters: UIReportV2SaleLineItemQuery
    ) => {
      return new ReportV2Client(
        activeAccountWebClientConfig
      ).getSaleLineItemReportSummary({
        ...tempReportConfig.request,
        filters,
        // Explicitly ensure useAccountCurrency is included if it exists
        useAccountCurrency: (tempReportConfig.request as any)
          .useAccountCurrency,
      });
    },
    [activeAccountWebClientConfig]
  );

  return (
    <FilterQueryContextProvider<UIReportV2SaleLineItemQuery>
      initialQuery={reportConfig.request.filters as UIReportV2SaleLineItemQuery}
      emptyQuery={EmptyReportV2SaleLineItemQuery}
      loadQueryFromUrl={false}
    >
      <ReportMetricsContextProviderV2<UIReportV2SaleLineItemQuery>
        queryKey="getReportSaleLineItemMetricsV2"
        getReportMetrics={getReportMetrics}
        getReportMetricsSummary={getReportMetricsSummary}
        disabled={isExport}
        reportConfig={reportConfig}
      >
        {children}
      </ReportMetricsContextProviderV2>
    </FilterQueryContextProvider>
  );
}
